import { getCategoricalLabels } from '../SocialValueByStakeholders/socialValueByStakeholdersHelpers'
import { CATEGORICAL_IMPACT, REGIONAL_IMPACT, REGION_NAME } from '../fields'

export const getFilteredReportData = ({
  report,
  selectedRegion,
  selectedStakeholder,
  fieldName = null,
  skipStakeholderFilter = false
}) => {
  if (selectedStakeholder && !skipStakeholderFilter) {
    // Stakeholder filter applied
    const categoricalImpact = report[CATEGORICAL_IMPACT] || []
    const labels = getCategoricalLabels(categoricalImpact)
    const selectedIndex = labels.findIndex(label => label === selectedStakeholder)
    const categoricalItem = categoricalImpact[selectedIndex]
    return fieldName ? categoricalItem?.[fieldName] : categoricalItem
  } else if (selectedRegion) {
    // Regional filter applied
    const regionData = report[REGIONAL_IMPACT]?.find(
      region => region[REGION_NAME]?.toLowerCase() === selectedRegion.toLowerCase()
    )
    return fieldName ? regionData?.[fieldName] : regionData
  } else {
    // No filters applied
    return fieldName ? report[fieldName] : report
  }
}
